// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2pXDQ","title":"AfterBackImages_title__2mczW","images":"AfterBackImages_images__3cfs9"};